<template lang="pug">
  .container.grid-xl
    page-title(icon="fas fa-image" :title="title" :subtitle="subtitle")
    .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
    fieldset(v-else :disabled="loading")
      form(@submit.prevent="onSubmit")
        .columns
          .column.col-6.col-lg-7.col-md-8.col-sm-12
            form-group(label="Título" :validation="$v.banner" field="title")
              input.form-input(v-model.trim="$v.banner.title.$model")
            form-group(label="Descrição" :validation="$v.banner" field="description")
              textarea.form-input(v-model.trim="$v.banner.description.$model" rows="5")
            .divider
            form-group(label="Tipo de banner" :validation="$v.banner" field="type")
              select.form-select(v-model="$v.banner.type.$model")
                option(v-for="bannerType in bannerTypes" :value="bannerType.key") {{bannerType.label}}
            .columns
              form-group.column.col-6.col-xs-12(label="Idioma" :validation="$v.banner" field="language")
                select.form-select(v-model="$v.banner.language.$model")
                  option(:value="null")
                  option(v-for="language in languages" :value="language.key") {{language.label}}
              form-group.column.col-6.col-xs-12(v-if="banner.type === 'landing_page'" label="Dispositivo" :validation="$v.banner" field="platform")
                select.form-select(v-model="$v.banner.platform.$model")
                  option(:value="null")
                  option(v-for="platform in platforms" :value="platform.key") {{platform.label}}
                  .divider
              form-group.column.col-6.col-xs-12(v-else label="Ação" :validation="$v.banner" field="action")
                input.form-input(v-model.trim="$v.banner.action.$model" placeholder="https://sua-url.com.br")
            .columns
              .column.col-6
                form-switch(v-model="banner.active" label="Ativo" @input="onChangeActive")
              .column.col-6(v-if="banner.type === 'store'")
                form-switch(v-model="banner.blankPage" label="Abir uma página em branco" :disabled="!banner.active")
            .divider
            form-group(label="Imagem" :validation="$v.banner" field="photoURL")
              file-upload(
                v-model="$v.banner.photoURL.$model"
                :input-attrs="{ accept: 'image/*' }"
                @upload-start="uploading = true"
                @upload-end="uploading = false"
              )
            .divider
            .text-right
              button.btn.btn-primary(:disabled="disabled") Salvar
</template>

<script>
import banners from '@/services/banners'
import { required, url } from 'vuelidate/lib/validators'
import requiredIf from 'vuelidate/lib/validators/requiredIf'

export default {
  data() {
    return {
      uploading: false,
      loading: false,
      error: null,
      banner: {
        title: '',
        description: '',
        action: '',
        blankPage: false,
        active: true,
        photoURL: '',
        platform: null,
        language: null,
        type: 'store',
      },
      platforms: [
        { key: 'mobile', label: 'Celular' },
        { key: 'desktop', label: 'Computador' },
      ],
      languages: [
        { key: 'pt', label: 'Português' },
        { key: 'en', label: 'Inglês' },
      ],
      bannerTypes: [
        { key: 'store', label: 'Loja' },
        { key: 'landing_page', label: 'Landing Page' },
      ],
    }
  },
  validations: {
    banner: {
      title: { required },
      description: { required },
      action: { url, required: requiredIf(model => model.type === 'store') },
      photoURL: { required },
      platform: {
        required: requiredIf(model => model.type === 'landing_page'),
      },
      language: { required },
      type: { required },
    },
  },
  computed: {
    disabled() {
      return this.uploading || this.loading || this.$v.$invalid
    },
    title() {
      return this.$route.params.id ? 'Editar banner' : 'Novo banner'
    },
    subtitle() {
      return 'Este banner aparecerá na tela inicial do Acervo'
    },
  },
  methods: {
    onChangeActive(newValue) {
      if (newValue === false) this.banner.blankPage = false
    },
    async onSubmit() {
      const { banner } = this
      const submitFunction = banner.id ? banners.update : banners.create
      try {
        this.loading = true
        await submitFunction(this.banner)
        this.$toaster.success('O banner foi salvo')
        this.$router.back()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
  async created() {
    if (!this.$route.params.id) return
    try {
      const { data } = await banners.show(this.$route.params.id)
      this.banner = data
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
}
</script>

<style lang="stylus" scoped>
img
  margin-top 1.65rem
</style>
